import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, ConfirmDialog, Dialog, InputText, Toast } from "primereact";

import AutoCompleteDropdown from "../../../../../Base/Components/Form/AutoCompleteDropdown";
import { useForm } from "../../../../../Base/Hooks/useForm";
import { toastShow } from "../../../../../Base/Services/ToastService";

import { getEstadosCategory } from "../../../../../API/Global/Status/StatusRequests";
import {
  addBodega,
  getBodegas,
} from "../../../../../API/Suministros/SuministrosRequest";
import Loader from "../../../../../Base/Components/Loader/Loader";
import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";
import { getAccesosScanner } from "../../../../../Base/API/IT/Accesos/AccesosRequests";

const BodegasCrudModal = ({
  bodega,
  bodegasDialog,
  setBodegasDialog,
  toastRef,
  getBodega,
  modo,
}) => {
  const toastDialog = useRef(null);
  const toast = useRef(null);
  const { userAuth } = useContext(AuthContext);

  const [show, setShow] = useState(false);
  const [estados, setEstados] = useState([{}]);
  const [bod, setBod] = useState([{}]);
  const [accesoDespacho, setAccesoDespacho] = useState([]);
  const [loading, setLoading] = useState(false);

  const initialValues = {
    IdBodega: -1,
    NombreBodega: "",
    IdStatus: bodega ? bodega?.IdStatus : 5,
    IdAcceso: null, // Aquí se inicializa como null
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } =
    useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);
    const estadosTempo = await getEstadosCategory("General");
    setEstados(estadosTempo);

    const accesos = await getAccesosScanner();
    setAccesoDespacho(accesos);

    const b = await getBodegas();
    setBod(b);

    // Si el modo es "Crear", no establece acceso inicial
    const estadoInicial =
      modo === "Crear"
        ? estadosTempo[0]
        : estadosTempo.find((e) => e.IdStatus === bodega?.IdStatus);

    const accesoInicial =
      modo === "Crear"
        ? null
        : accesos.find((e) => e.IdAccess === bodega?.IdAcceso);

    setValues({
      ...bodega,
      Estado: estadoInicial,
      IdStatus: estadoInicial?.IdStatus,
      Acceso: accesoInicial,
      IdAcceso: accesoInicial?.IdAccess,
    });
    setLoading(false);
  };

  const onHide = () => {
    setBodegasDialog(false);
    resetForm();
    setShow(false);
  };

  const verificarInfo = () => {
    let error = {};
    if (!values.NombreBodega) {
      error.NombreBodega = true;
      error.error = true;
    }
    if (!values.Estado || !values.Estado.IdStatus) {
      error.IdStatus = true;
      error.error = true;
    }
    if (!values.Acceso || !values.Acceso.IdAccess) {
      error.IdAcceso = true;
      error.error = true;
    }
    setError(error);
    return error;
  };

  const agregarBodega = async () => {
    const e = verificarInfo();
    if (!e.error) {
      const existingBodega = bod.find(
        (cur) => cur.NombreBodega === values?.NombreBodega
      );
      if (
        existingBodega &&
        (modo === "Crear" || existingBodega.IdBodega !== values.IdBodega)
      ) {
        toastShow(
          toast,
          "error",
          "Error",
          "Ya existe una Bodega con ese nombre"
        );
      } else {
        let estadoId = null;
        if (values.Estado) {
          estadoId = values.Estado.IdStatus;
        }
        const a = {
          IdBodega: values?.IdBodega,
          NombreBodega: values.NombreBodega.toLowerCase().replace(
            /\b\w+\b/g,
            (word) => {
              return word.length <= 3
                ? word
                : word.charAt(0).toUpperCase() + word.slice(1);
            }
          ),
          IdStatus: estadoId,
          IdAcceso: values?.Acceso.IdAccess,
          IdUserCreate: userAuth?.IdUser,
        };

        const resultado = await addBodega(a);
        if (modo === "Crear") {
          onHide();
          toastShow(
            toastRef,
            "success",
            "Datos Agregados",
            "Bodega agregada exitosamente."
          );
          getBodega();
        } else {
          onHide();
          toastShow(
            toastRef,
            "success",
            "Datos modificados",
            "Bodega modificada exitosamente."
          );
          getBodega();
        }
      }
    }
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={modo === "Crear" ? "Guardar" : "Modificar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={agregarBodega}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (bodegasDialog) {
      getValoresIniciales();
    }
  }, [bodegasDialog]);

  const dialogTitle = modo === "Crear" ? "Agregar Bodega" : "Modificar Bodega";

  return (
    <div>
      <Toast ref={toast} style={{ zIndex: 50000 }} />
      <Dialog
        visible={bodegasDialog}
        modal
        className="modal__contenedor modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
      >
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
          <div style={{ width: "100", margin: "auto" }}>
            <div className="d-flex align-items-center">
              <h2 className="me-3">{dialogTitle}</h2>
            </div>
            <Toast ref={toastDialog} style={{ zIndex: 50000 }} />

            <div className="modal__input-contenedor">
              <div className="field col-6 me-2  mt-2">
                <span className="p-float-label">
                  <InputText
                    name="NombreBodega"
                    value={values.NombreBodega}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.NombreBodega ? "p-invalid" : ""}
                  />
                  <label htmlFor="NombreBodega">Nombre de Bodega</label>
                </span>
              </div>

              <div className="field col-6 me-2 mt-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Estado"}
                    value={values.Estado}
                    items={estados}
                    field={"StatusName"}
                    label={"Estado"}
                    handleInputChange={handleInputChange}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IdStatus ? "p-invalid" : ""}
                  />
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor">
              <div className="field col-6 me-2 mt-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Acceso"}
                    value={values.Acceso}
                    items={accesoDespacho}
                    field={"Access"}
                    label={"Acceso"}
                    handleInputChange={handleInputChange}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IdAcceso ? "p-invalid" : ""}
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default BodegasCrudModal;
